module.exports = __webpack_public_path__ + "img/scroll-up.acdd0cba.svg";